import type { ClassListContext } from '@/features/class/classListContext';

/** Joined class — member empty preview (no management actions). */
export const CLASS_EMPTY_MEMBER_CODE = 'BIO202';

/** Owned class — owner empty preview (management actions, “Class Owner” in members). */
export const CLASS_EMPTY_OWNER_CODE = 'PSYC101';

/** Joined class — admin empty preview (management actions, “Class Admin” in members). */
export const CLASS_EMPTY_ADMIN_CODE = 'HIST301';

export type ClassEmptyPreviewMode = 'member' | 'owner' | 'admin';

export function isPrivilegedClassEmptyPreview(
  mode: ClassEmptyPreviewMode | null,
): mode is 'owner' | 'admin' {
  return mode === 'owner' || mode === 'admin';
}

export function getClassEmptyPreviewMode(
  classCode: string,
  listContext?: ClassListContext | null,
): ClassEmptyPreviewMode | null {
  const normalized = classCode.toUpperCase();

  if (normalized === CLASS_EMPTY_OWNER_CODE) {
    return listContext === 'owned' ? 'owner' : null;
  }

  if (normalized === CLASS_EMPTY_ADMIN_CODE) {
    return listContext === 'joined' ? 'admin' : null;
  }

  if (normalized === CLASS_EMPTY_MEMBER_CODE) {
    return 'member';
  }

  return null;
}

export function isClassEmptyPreview(
  classCode: string,
  listContext?: ClassListContext | null,
): boolean {
  return getClassEmptyPreviewMode(classCode, listContext) !== null;
}
